<template>
  <div ref="heroBlock" class="pages-home-hero" :style="{
    '--background-color': props.hero?.backgroundColor?.hex || 'transparent',
    '--text-color': props.hero?.textColor?.hex || '#BC5839',
  }">
    <!-- Hero Side Media (only desk) -->
    <div v-if="props.hero?.leftMedia" class="pages-home-hero__side-media --left show-for-large">
      <WidgetVideo
        v-if="props.hero?.leftMedia.videoUrl"
        class="pages-home-hero__side-media__video is-cover"
        :videoUrl="props.hero?.leftMedia.videoUrl"
        :loop="true"
        :forcePlay="true"
        :autoplay="true"
        :muted="true"
        :controls="false"
      />
      <WidgetPicture
        v-else-if="props.hero?.leftMedia?.image?.responsiveImage"
        :image="{ custom: props.hero.leftMedia.responsiveImage}"
        :lazyLoad="false"
        :alt="props.hero?.leftMedia?.responsiveImage?.alt"
      />
    </div>
    <div v-if="props.hero?.rightMedia" class="pages-home-hero__side-media --right show-for-large">
      <WidgetVideo
        v-if="props.hero?.rightMedia.videoUrl"
        class="pages-home-hero__side-media__video is-cover"
        :videoUrl="props.hero?.rightMedia.videoUrl"
        :loop="true"
        :forcePlay="true"
        :autoplay="true"
        :muted="true"
        :controls="false"
      />
      <WidgetPicture
        v-else-if="props.hero?.rightMedia?.image?.responsiveImage"
        :image="{ custom: props.hero.rightMedia.responsiveImage}"
        :lazyLoad="false"
        :alt="props.hero?.rightMedia?.responsiveImage?.alt"
      />
    </div>

    <!-- Hero Title (forced on Top) -->
    <div v-if="props.hero?.title && props.hero?.forceTitleOnTop" class="pages-home-hero__title__top">
      <div
        data-animate="preloader-reveal"
        class="title-l-1 pages-home-hero__title is-text-uppercase"
        v-html="props.hero.title"
      />
    </div>

    <!-- Hero Intro-->
    <div class="pages-home-hero__intro">
      <div v-if="props.hero.introLeftText" class="pages-home-hero__intro__text show-for-small title-xs-1">
        <div v-html="props.hero.introLeftText" />
      </div>

      <div v-if="props.hero.introImage" class="pages-home-hero__intro__image">
        <div v-if="props.hero.introLeftText" class="pages-home-hero__intro__text show-for-medium title-xs-1">
          <div v-html="props.hero.introLeftText" />
        </div>

        <div class="pages-home-hero__intro__image__curtain"></div>

        <WidgetPicture
          :image="{ custom: props.hero.introImage.responsiveImage}"
          :lazyLoad="false"
          :alt="props.item?.image?.responsiveImage?.alt"
        />

        <div v-if="props.hero.introRightText" class="pages-home-hero__intro__text show-for-medium title-xs-1">
          <div v-html="props.hero.introRightText" />
        </div>
      </div>

      <div v-if="props.hero.introRightText" class="pages-home-hero__intro__text show-for-small title-xs-1">
        <div v-html="props.hero.introRightText" />
      </div>
    </div>

    <!-- Hero Text Block -->
    <div class="pages-home-hero__text__wrap">
      <div
        class="pages-home-hero__text__content row-1"
        :class="{ '--white-text': props.hero?.whiteText }"
      >
        <div
          v-if="props.hero?.title && !props.hero?.forceTitleOnTop"
          data-animate="preloader-reveal"
          class="title-l-1 pages-home-hero__title is-text-uppercase"
          v-html="props.hero.title"
        />
        <div
          v-if="props.hero?.subtitle"
          data-animate="preloader-opacity"
          class="pages-home-hero__subtitle text-corpo-xl is-xlight"
          v-html="props.hero.subtitle"
        />
      </div>
    </div>

    <!-- Hero Bottom Image (opzionale) -->
    <div v-if="props.hero.bottomImage?.responsiveImage" class="pages-home-hero__bottom-img">
      <WidgetPicture
        :image="{ custom: props.hero.bottomImage?.responsiveImage}"
        :lazyLoad="false"
        :alt="props.hero.bottomImage?.responsiveImage?.alt"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesHomeHero',
}
</script>

<script setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const props = defineProps({
  hero: Object,
})

const heroBlock = ref(null)
const introBlock = ref(null)

const route = useRoute()

const lenis = inject('lenis')

const splitAndAnimateText = (el, duration = 0.8) => {
  new SplitType(el, { types: 'words, lines' })

  gsap.set(el.querySelectorAll('.line'), { overflow: 'hidden' })
  gsap.set(el.querySelectorAll('.word'), { y: '110%' })

  const tl = gsap.timeline({ paused: true })

  el.querySelectorAll('.line').forEach((line, index) => {
    tl.to(
      line.querySelectorAll('.word'),
      {
        y: '0%',
        ease: 'power2.out',
        duration,
      },
      index * 0.05
    )
  })

  return tl
}
const animate = async () => {
  // const header1Animation = splitAndAnimateText(header1.value)
  // const header2Animation = splitAndAnimateText(header2.value)
  const introTexts = document.querySelectorAll('.pages-home-hero__intro__text')
  const introImageCurtain = document.querySelector('.pages-home-hero__intro__image__curtain')
  const bottomHeroImage = document.querySelector('.pages-home-hero__bottom-img')
  // const sideMedia = document.querySelectorAll('.pages-home-hero .pages-home-hero__side-media')

  const tl = gsap.timeline({
    paused: true,
    onComplete: async () => {
      // console.log('done')
    },
  })

  // Prepariamo i vari blocchi..
  // tl.set([pretitle1.value.querySelectorAll('.line')], { overflow: 'hidden' })
  // tl.set([pretitle1.value.querySelectorAll('.word')], { y: '110%' })
  if (introTexts?.length) tl.set(introTexts,  { autoAlpha: 0})
  if (introImageCurtain) tl.set(introImageCurtain, { scaleY: 1 })
  if (bottomHeroImage) tl.set(bottomHeroImage, { autoAlpha: 0, })
  // if (sideMedia?.length) tl.set(sideMedia, { autoAlpha: 0 })

  if (introImageCurtain) tl.to(introImageCurtain, { scaleY: 0, ease: "power2.inOut", duration: .8 });
  if (introTexts?.length) tl.to(introTexts, { autoAlpha: 1, duration: .6, stagger: 0.25 });
  // if (sideMedia?.length) tl.to(sideMedia, { opacity: 1, duration: .6, stagger: 0.25 });
  if (bottomHeroImage) tl.to(bottomHeroImage, { autoAlpha: 1, duration: .6 })

  await tl.play()
}

onMounted(() => {
  animate()
})

onUnmounted(() => {
  // ScrollTrigger.refresh()
})
</script>

<style lang="scss">
@import './style.scss';

.v-enter-active,
.v-leave-active {
  transition: opacity $speed-fast ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
